export default __webpack_public_path__ + "static/media/male1.bd79c3fc.png";